import { defineMessages } from '@alltrails/shared/react-intl';

export const LETTER = 'letter';
export const LEGAL = 'legal';
export const TABLOID = 'tabloid';

export const A2 = 'a2';
export const A3 = 'a3';
export const A4 = 'a4';

export const CUSTOM = 'custom';

export const IMPERIAL_SIZES = [LETTER, LEGAL, TABLOID, CUSTOM];
export const METRIC_SIZES = [A2, A3, A4, CUSTOM];

export const PAPER_SIZE_LABELS = defineMessages({
  letter: { defaultMessage: 'Letter' },
  legal: { defaultMessage: 'Legal' },
  tabloid: { defaultMessage: 'Tabloid' },
  a2: { defaultMessage: 'A2' },
  a3: { defaultMessage: 'A3' },
  a4: { defaultMessage: 'A4' },
  custom: { defaultMessage: 'Custom' }
});

export const DIMENSIONS = {
  [LETTER]: [8.5, 11],
  [LEGAL]: [8.5, 14],
  [TABLOID]: [11, 17],
  [A2]: [16.5, 23.2],
  [A3]: [11.7, 16.5],
  [A4]: [8.3, 11.7],
  [CUSTOM]: [16, 16]
};

export const PORTRAIT = 'portrait';
export const LANDSCAPE = 'landscape';

export const ORIENTATION_LABELS = defineMessages({
  portrait: { defaultMessage: 'Portrait' },
  landscape: { defaultMessage: 'Landscape' }
});

export const DECIMAL = 'decimal';
export const DMS = 'dms';
export const UTM = 'utm';
export const NONE = 'none';

export const GRID_LABELS = defineMessages({
  decimal: { defaultMessage: 'Decimal' },
  dms: { defaultMessage: 'D°M’S”' },
  utm: { defaultMessage: 'UTM' },
  none: { defaultMessage: 'None' }
});

export const scales = intl => ({
  // # 19: '1:1k',
  18: intl.formatMessage({ defaultMessage: '1:2k' }),
  17: intl.formatMessage({ defaultMessage: '1:4k' }),
  '-5': intl.formatMessage({ defaultMessage: '1:5k Exact' }),
  16: intl.formatMessage({ defaultMessage: '1:9k' }),
  '-6': intl.formatMessage({ defaultMessage: '1:10k Exact' }),
  15: intl.formatMessage({ defaultMessage: '1:18k' }),
  '-1': intl.formatMessage({ defaultMessage: '1:24k Exact' }),
  '-2': intl.formatMessage({ defaultMessage: '1:25k Exact' }),
  14: intl.formatMessage({ defaultMessage: '1:36k' }),
  '-3': intl.formatMessage({ defaultMessage: `1:50k Exact` }),
  13: intl.formatMessage({ defaultMessage: '1:72k' }),
  '-4': intl.formatMessage({ defaultMessage: '1:100k Exact' }),
  12: intl.formatMessage({ defaultMessage: '1:144k' }),
  11: intl.formatMessage({ defaultMessage: '1:289k' }),
  10: intl.formatMessage({ defaultMessage: '1:578k' }),
  9: intl.formatMessage({ defaultMessage: '1:1m' }),
  8: intl.formatMessage({ defaultMessage: '1:2m' }),
  7: intl.formatMessage({ defaultMessage: '1:5m' }),
  6: intl.formatMessage({ defaultMessage: '1:9m' }),
  5: intl.formatMessage({ defaultMessage: '1:18m' }),
  4: intl.formatMessage({ defaultMessage: '1:37m' }),
  3: intl.formatMessage({ defaultMessage: '1:74m' }),
  2: intl.formatMessage({ defaultMessage: '1:148m' })
  // # 1:  '1:296m',
});
